import 'twin.macro';

import { Loading } from '@cheqroom/icons';
import { ComponentPropsWithoutRef, FC } from 'react';

import { Icon, type Size } from '../Icon/Icon';

type Props = Omit<ComponentPropsWithoutRef<typeof Icon>, 'source'> & {
	size?: Size;
};

export const LoadingSpinner: FC<Props> = ({ size = 'medium', ...rest }) => (
	<Icon source={Loading} size={size} tw="animate-spin text-indigo-500" {...rest} />
);
